$(function(){
    $('.drawer-open').click(function(){
      $(this).toggleClass('clicked');
      $('.drawer-content').toggleClass('clicked');
          $('.drawer-content-bg').toggleClass('clicked');
    });
  });

function GethashID (hashIDName){
	if(hashIDName){
		//タブ設定
		$('.blog_tab li').find('a').each(function() { 
			var idName = $(this).attr('href'); 
			if(idName == hashIDName){ 
				var parentElm = $(this).parent(); 
				$('.blog_tab li').removeClass("blog_active"); 
				$(parentElm).addClass("blog_active"); 
				$(".blog_area").removeClass("blog_is-active"); 
				$(hashIDName).addClass("blog_is-active"); 
			}
		});
	}
}

$('.blog_tab a').on('click', function() {
	var idName = $(this).attr('href'); 
	GethashID (idName);
	return false;
});

$(window).on('load', function () {
    $('.blog_tab li:first-of-type').addClass("blog_active"); 
    $('.blog_area:first-of-type').addClass("blog_is-active"); 
	var hashName = location.hash; 
	GethashID (hashName);
});